import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { DataTableLoading } from '@/catalog-apps/components/component-library/DataTableComponent/DataTableLoading'
import { DataTable } from '@/components/ui/DataTable'
import { Button } from '@/components/shadcn/button'
import { TablePageContainer } from '@/components/ui/DataTable/PageTableContainer'
import { useRestClient } from '@/contexts/QueryProvider'
import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Suspense } from 'react'
import { WorkspaceSettingForm } from '../Forms/WorkspaceSettingForm'
import { WorkspacesBreadcrumbs } from '../WorspacesBreadcrumbs'
import { useCurrentWorkspace } from '../useCurrentWorkspace'
import { workspaceSettingsColumns } from './WorkspaceSettingsTable/workspaceSettingsColumns'

export const WorkspaceSettingsPage = () => {
  return (
    <>
      <WorkspacesBreadcrumbs title="Settings" />
      <QueryErrorBoundary errorMessage="Failed to fetch workspace settings">
        <Suspense fallback={<DataTableLoading />}>
          <WorkspaceSettingsPageContent />
        </Suspense>
      </QueryErrorBoundary>
    </>
  )
}

function WorkspaceSettingsPageContent() {
  const { workspaceId } = useCurrentWorkspace()
  const { getWorkspacesApiGetWorkspaceSettings } = useRestClient()
  const { data: settings } = getWorkspacesApiGetWorkspaceSettings.useSuspenseQuery({
    query: { workspaceId },
  })

  return (
    <TablePageContainer>
      <DataTable
        columns={workspaceSettingsColumns}
        data={settings ?? []}
        action={
          <WorkspaceSettingForm
            sheetTitle="Add setting"
            sheetTrigger={
              <Button size="lg" variant="outline">
                <IconPlusOutline className="mr-2" />
                Add setting
              </Button>
            }
          />
        }
      />
    </TablePageContainer>
  )
}
